import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { getContractCenterReviewBeforeApprove } from '../../../redux/actions/proposeConsiderApproveProject'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ContractCenterCommentBeforeApproveWidget from '../../../widgets/contractCenterCommentBeforeApproveWidget/ContractCenterCommentBeforeApproveWidget'

export default function ContractCenterCommentBeforeApprove() {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    console.log('load ObjectiveGoal proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getContractCenterReviewBeforeApprove(proposalId)
      //console.log('schema ', _schema.forms)
      //setSchema(mockSchema)
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ContractCenterCommentBeforeApproveWidget
            showCommandButton={!schema?.forms.disabled || schema.isCoordinator}
            schema={schema?.forms}
            onSuccess={() => handleGetSchema(projectId)}
          />
          <br />
        </SidebarProposal>
      )}
    </>
  )
}

// const mockSchema = {
//   header: 'ผลการตรวจสอบ/ความคิดเห็นจากศูนย์สัญญา',
//   subHeader: 'ฟฟฟฟฟ แก้ status 4 ทดสอบ 1',
//   projectInfo: null,
//   forms: {
//     header: 'ผลการตรวจสอบ/ความคิดเห็นจากศูนย์สัญญา',
//     buttonText: 'บันทึกผลการตรวจสอบ/ความคิดเห็นจากศูนย์สัญญา',
//     status: 0,
//     isCoordinator: true,
//     disabled: true,
//     editorData: {
//       name: 'editorData',
//       label: 'ผลการตรวจสอบ/ความคิดเห็นจากศูนย์สัญญา',
//       value: '<p>testy</p>\n',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณาระยุ ผลการตรวจสอบ/ความคิดเห็นจากศูนย์สัญญา',
//         },
//         {
//           type: 'MAXLENGTH',
//           value: 8000,
//           errorMessage: 'ข้อความเกิน 8000 อักขระ',
//         },
//       ],
//       processStatus: 0,
//     },
//     contratCenterApprove: {
//       name: 'contratCenterApprove',
//       label: 'ผ่านการตรวจสอบ เสนออนุมัติโครงการได้',
//       value: false,
//       processStatus: 0,
//     },
//   },
// }
